import { Col, Form, Input, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import { ModalSizes, rowGutter } from "../../../../common/constants";
import { resolveFormValidationError, useFormErrorHandler } from "../../../../common/utils/formUtils";
import { useRequestFinishedCallback } from "../../../../common/utils/hooksUtils";
import { validations } from "../../../../common/utils/validationUtils";
import { requests } from "../../api";
import { userDeleteUserTotpDeviceActions } from "../../ducks";
import { DeleteUserTotpDevice, UserProfile, UserTotpDevice } from "../../types";

interface Props {
  user: UserProfile;
  totpDevice?: UserTotpDevice;
  onDelete: typeof userDeleteUserTotpDeviceActions.request;
  onFormCancel: () => void;
}

const DeleteUserTotpDeviceForm = ({ user, totpDevice, onDelete, onFormCancel }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<DeleteUserTotpDevice>();
  useFormErrorHandler(form, "user.totpDevice.attrs", [requests.USER_DELETE_USER_TOTP_DEVICE]);

  const inProgress = useRequestFinishedCallback([requests.USER_DELETE_USER_TOTP_DEVICE], onFormCancel);

  const handleFormSubmit = (): void => {
    if (totpDevice) {
      form
        .validateFields()
        .then(values => {
          onDelete({ id1: user.id, id2: totpDevice.id, object: values });
        })
        .catch(resolveFormValidationError);
    }
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      open={!!totpDevice}
      title={t("user.totpDevice.titles.delete")}
      okText={t("common.delete")}
      cancelText={t("common.cancel")}
      confirmLoading={inProgress}
      afterClose={() => form.resetFields()}
      onOk={handleFormSubmit}
      onCancel={onFormCancel}
    >
      <Form form={form} layout="vertical" name="deleteUserTotpDeviceForm">
        <Row gutter={rowGutter}>
          <Col span={24}>
            <Form.Item name="password" label={t("user.totpDevice.attrs.password")} rules={[validations.notBlank]}>
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default DeleteUserTotpDeviceForm;
